// src/components/AddCompanyForm/RegionsCard.jsx
import React, { useState, useMemo } from "react";
import { Card, CardHeader, CardContent, Grid, TextField, Button, Typography, Stack, Chip } from "@mui/material";
import { slugify, uid } from "./utils";

export default function RegionsCard({ regioes, setRegioes }) {
  const [newRegionLabel, setNewRegionLabel] = useState("");

  const addRegion = () => {
    const clean = (newRegionLabel || "").trim();
    if (!clean) return;
    const key = slugify(clean);
    if (!key) return alert("Nome de marca inválido.");
    if (regioes.some((r) => r.region_key === key)) return alert("Essa marca já existe.");
    setRegioes((prev) => [...prev, { _id: uid(), region_key: key, label: clean, ordem: prev.length, status: 1 }]);
    setNewRegionLabel("");
  };
  const removeRegion = (id) => setRegioes((p) => p.filter((r) => r._id !== id));
  const onRegionKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addRegion();
    }
  };

  return (
    <Card variant="outlined">
      <CardHeader title="Regiões do projeto" subheader="projetos_regioes" />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <Grid item xs={12} md={8}>
            <TextField
              label="Nova marca — nome/label"
              value={newRegionLabel}
              onChange={(e) => setNewRegionLabel(e.target.value)}
              onKeyDown={onRegionKeyDown}
              fullWidth
              placeholder="Workspace da marca"
              helperText="Deve ser exatamente igual ao workspace da marca"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Button variant="outlined" onClick={addRegion} fullWidth>
              Adicionar
            </Button>
          </Grid>
        </Grid>

        {regioes.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Nenhuma marca definida.
          </Typography>
        ) : (
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {regioes.map((r) => (
              <Chip key={r._id} label={`${r.label} (${r.region_key})`} onDelete={() => removeRegion(r._id)} variant="outlined" sx={{ mb: 1 }} />
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}

export const useRegionKeys = (regioes) => useMemo(() => regioes.map((r) => r.region_key), [regioes]);
